import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  outerContainer: {
    zIndex: 1,
  },
  innerContainer: (props: any) => ({
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    rowGap: "1.5rem",
    right: 0,
    top: 0,
    width: "fit-content",
    height: "fit-content",
    padding: "1.3rem 2rem",
    opacity: props.open ? 0.8 : 0,
    pointerEvents: props.open ? "fill" : "none",
    backgroundColor: theme.darkSlateGrayColor,
    transition: "all 300ms ease-in-out",
  }),
  btn: (props: any) => ({
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    border: "none",
    padding: "0.3rem",
    color: theme.whiteColor,
    backgroundColor: "inherit",
    fontSize: "1rem",
    fontFamily: theme.fontFamilyQuestrial,
    cursor: "pointer",
    "&::before": {
      content: '""',
      position: "absolute",
      left: "-15px",
      top: "11px",
      display: props.selected ? "block" : "none",
      width: "7px",
      height: "7px",
      marginRight: "0.5rem",
      borderRadius: "50%",
      backgroundColor: theme.lightCoralColor,
    },
  }),
}));

export default useStyles;
